/**
 * Legal page configuration for Raisy.
 * Sourced from /home/david/playano-docs/legal/app-configs.json (app key "raisy").
 * __FILL_IN__ placeholders were manually completed on 2026-09-01 per the
 * backend code audit. Keep this file in sync with legalContent.ts.
 */
export const LEGAL_CONFIG = {
  companyName: 'Raisy',
  companyLegalDescription: 'the organization operating raisy.team',
  companyAddress: 'We do not maintain a public postal address; please contact us by email.',
  contactEmail: 'support@playanoedu.com',
  domain: 'raisy.team',
  effectiveDate: '2026-08-31',
  lastUpdated: '2026-09-01',
  governingLawJurisdiction: 'Hong Kong',
  governingLawCourts: 'Hong Kong',
  analyticsProviders: 'Firebase Analytics',
  advertisingProviders: '',
  authProviders: 'Firebase Auth, Google OAuth, LinkedIn OAuth',
  paymentProcessors: 'Stripe may be invoked by an agent tool for payment links; there are no self-service subscriptions or cancellations, and services are currently free of charge.',
} as const;

export const LEGAL_ROUTES = {
  privacy: '/privacy_policy',
  terms: '/terms_of_service',
  cookie: '/cookie_policy',
  dmca: '/dmca',
  accessibility: '/accessibility',
  contact: '/contact',
} as const;
